import "../../../src/App.css";
import Supplier from "../../components/Supplier/Supplier";
import AddSupplier from "../../components/AddSupplier/AddSupplier";
import Navbar from "../../components/Navbar/navbar";
import Sidebar from "../../components/Sidebar/Sidebar";
import SupplierList from "../../components/SupplierList/SupplierList";
import React, { useState, useEffect } from "react";
import axios from "axios";
import MasterTopButtons from "../../components/MasterTopButtons/MasterTopButtons";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import PaginationLink from "../../components/Pagination/Pagination";
import Wrapper from "../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import AddVendor from "../../components/AddVendor/AddVendor";
import AddVendorDetails from "../../components/AddVendorDetails/AddVendorDetails";
import ExcelExport from "../../components/ExcelExport/ExcelExportAccounts";
import filterIcon from "../../Icons/filterIcon.png";


function SupplierMaster() {
  const isAdmin = localStorage.getItem("isAdmin");
  const [supplierDetailResponse, setSupplierDetailResponse] = useState(null);
  const [openProfile, setOpenProfile] = useState(false);
  const [openAddProfile, setOpenAddProfile] = useState(false);
  const [guid, setGuid] = useState("");
  const [selectedSupplierId, setSelectedSupplierId] = useState();
  const [vendorData, setVendorData] = useState(null);
  const [openAddVendor, setOpenAddVendor] = useState(false); 
  const title = "Add Supplier";
  const heading = "Supplier List";
  const baseAPI = process.env.REACT_APP_API_URL;

  function tokenStorage() {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);

    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GETSupplier?SupplierID=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {          
          setSupplierDetailResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }
  useEffect(() => {
    tokenStorage();
  }, []);

  const GetId = (param) => {
    setSelectedSupplierId(param);
  };

  const handleVendorSubmit = (data) => {
    setVendorData(data);
  };

  const handleToggleAddVendor = () => {
    setOpenAddVendor((prev) => !prev); 
  };


  return (
    <>
      <div className="d-flex flex-row app">
        <MiniDrawer />
        <div
          className="container-fluid"
          style={{
            padding: "4rem 1rem 1rem 1rem",
            width: "94%",
            backgroundColor: "#F4F4F4",
          }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                  Vendor Details | <HomeOutlinedIcon />{" "}
                  <span style={{ fontSize: "20px" }}>&gt; Accounts & Finance</span>
                  <span style={{ fontSize: "20px",paddingLeft:"10px" }}>&gt; Vendor Registration Form</span>
                </h1>

              </div>
              <div style={{ width: "8rem" }}>
                <select className="form-control" name="country">
                  <option value="0">INDIA </option>
                  <option value="1">DUBAI </option>
                </select>
              </div>
            </div>
            <div>
              <Wrapper className="ViewLeadDetails">
                {/* <MasterTopButtons
                  title={''}
                  heading={''}
                  setOpenAddProfile={setOpenAddProfile}
                  openAddProfile={openAddProfile}
                  setOpenProfile = {setOpenProfile}
                /> */}
                {/* {supplierDetailResponse!==null && supplierDetailResponse.length!==0?
                 <ExcelExport supplierDetailResponse={supplierDetailResponse}/>

              :
              null
              } */}
                <div style={{ display: "flex", justifyContent: "space-between",marginBottom:"46px" }}>
                  <button className="filterButton">
                    <img src={filterIcon} />
                    {" "}FILTER
                  </button>
                  
                  <div style={{ display: "flex",justifyContent:"flex-end" }}
                  
                  >
                     <button style={{width:"32%",marginRight:"18px",paddingRight:"10px",fontSize:"17px",color:"rgb(106, 106, 106)",height:"48px",marginRight:"10px",border:" 1px solid #c0c6cc"}}
                    className=""
                    onClick={handleToggleAddVendor}
                  >
                    {openAddVendor  ? "Close" : "+ Add"}
                  </button>
                    {/* <p
                    className="icon"
                    style={{
                      textAlign: "center",
                      padding: "7px",
                      fontSize: "18px",
                      fontWeight: "bold",
                      width: "11rem",
                      height: "3rem",
                      borderRadius: "0.5rem",
                      color: "#6A6A6A",
                      backgroundColor: "white",
                      marginRight: "13px",
                    }}
                  >
                      {" "}
                    </p> */}
                    {isAdmin === "true" && (
                      <ExcelExport supplierDetailResponse={supplierDetailResponse} />)}
                  </div>
                  
                </div>
                {openAddProfile ? (
                  <AddVendorDetails vendorData={vendorData} />
                ) : null}
                {openAddProfile ? (
                  <AddSupplier
                    guid={guid}
                    tokenStorage={tokenStorage}
                    openAddProfile={openAddProfile}
                    setOpenAddProfile={setOpenAddProfile}
                  />
                ) : null}
                {openProfile ? (
                  <Supplier
                    tokenStorage={tokenStorage}
                    openProfile={openProfile}
                    setOpenProfile={setOpenProfile}
                    selectedSupplierId={selectedSupplierId}
                  />
                ) : null}
                {openAddVendor && (
                <AddVendor
                setOpenAddVendor={setOpenAddVendor}
                  supplierDetailResponse={supplierDetailResponse}
                  onSubmit={handleVendorSubmit}
                  tokenStorage={tokenStorage}
                  openProfile={openProfile}
                  setOpenProfile={setOpenProfile}
                />
                )}

                <h2
                  className="Venderheading"
                  style={{
                    fontSize: "22px",
                    paddingLeft: "16px",
                    paddingTop: "7px",
                  }}
                >
                  Vendor List
                </h2>
                <SupplierList
                  supplierDetailResponse={supplierDetailResponse}
                  setOpenProfile={setOpenProfile}
                  openProfile={openProfile}
                  GetId={(param) => GetId(param)}
                  openAddProfile={openAddProfile}
                  setOpenAddProfile={setOpenAddProfile}
                />
                {/* <PaginationLink /> */}
              </Wrapper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SupplierMaster;
